export default "__VITE_ASSET__7088d006__"